import { CaseStatus } from '@debbie/common/dist/cases/index.js';
import { Site } from '@debbie/common/dist/index.js';
import { UpdateState, } from '@debbie/common/dist/updates/index.js';
import * as insightsAPI from '@debbie/cortex/dist/api/insights.js';
import { c, h } from '@debbie/cortex/dist/index.js';
import { useWorkflowStagesMap } from '@debbie/cortex/dist/workflow-stages/index.js';
import { useWorkflowStats } from '@debbie/cortex/dist/workflows/index.js';
import moment from 'moment';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
import AlertTriangle from '../Icons/AlertTriangle.js';
import ExternalLink from '../Icons/ExternalLink.js';
import { CornerDownRight } from '../Icons/index.js';
import Info from '../Icons/Info.js';
import Pause from '../Icons/Pause.js';
import Play from '../Icons/Play.js';
import Trash2 from '../Icons/Trash2.js';
import Zap from '../Icons/Zap.js';
import Loading from '../Loading.js';
import UserType from '../UserType.js';
import Procedure from './Procedure.js';
const style = {
    color: THEME.COLOR_ACCENT,
    margin: '0.15em 0 -0.15em',
};
const UpdateType = (props) => {
    const lang = useSelector((s) => s.lang);
    const site = useSelector((s) => s.site);
    const statsLoadable = useWorkflowStats(!props.caseContext ? props.workflowId || null : null, {});
    const stats = h.hasData(statsLoadable) ? statsLoadable.data : null;
    const workflowStagesMapLoadable = useWorkflowStagesMap();
    const workflowStagesMap = h.hasData(workflowStagesMapLoadable)
        ? workflowStagesMapLoadable.data
        : {};
    // null means the stage was explicitly cleared, so only fall back to the
    // task's stage when the prop was not provided at all
    const workflowStageId = props.workflowStageId !== undefined
        ? props.workflowStageId
        : props.task?.workflowStageId;
    const workflowStage = workflowStageId != null ? workflowStagesMap[workflowStageId] : null;
    const [redirecting, setRedirecting] = useState(false);
    const { onDelete, updateType, task } = props;
    const executedUpdate = props.caseContext &&
        props.caseContext.updates.find((update) => update.state === UpdateState.Executed && update.taskId === task?.id);
    const taskStats = stats &&
        task?.id &&
        stats.tasks.find((taskStats) => taskStats.taskId === task?.id);
    const endedCasesQty = taskStats
        ? taskStats.endedCases.reduce((acc, reason) => reason.count + acc, 0)
        : 0;
    const goToCases = async () => {
        if (!redirecting) {
            if (task) {
                setRedirecting(true);
                const caseQueue = await insightsAPI.getCaseFilterQueue({
                    currentTaskIds: [task.id],
                    caseStatuses: [CaseStatus.VERIFIED],
                });
                setRedirecting(false);
                c.redirect.redirect(`/cases/${caseQueue.join(',')}`);
            }
        }
    };
    const isClickable = props.caseContext
        ? props.isPossibleTask || !!executedUpdate
        : true;
    // Only workflow-editor nodes pass workflowStageId; the task palette and
    // procedure tasks have no stage to be missing
    const showMissingStage = props.workflowStageId !== undefined &&
        !props.caseContext &&
        Site.Caseworker === site;
    const showDeleteIcon = onDelete != null && !props.caseContext && Site.Caseworker === site;
    const showEditLinkIcon = !updateType.public && Site.Caseworker === site;
    return (React.createElement(UpdateTypeStyled, { disabled: !isClickable, onClick: (e) => {
            if (isClickable) {
                e.preventDefault();
            }
        } },
        executedUpdate && (React.createElement("h4", { style: {
                color: THEME.COLOR_ACCENT,
                marginTop: '0.5em',
            } }, moment(executedUpdate.pausedAt).format(THEME.DATE_FORMAT_LONG))),
        (workflowStage ||
            showMissingStage ||
            showDeleteIcon ||
            showEditLinkIcon) && (React.createElement(StageRow, null,
            React.createElement("div", null, workflowStage ? (React.createElement(WorkflowStageBadge, { "data-tooltip-content": lang.workflowStages.stage, "data-tooltip-id": "tooltip-default" }, workflowStage.label)) : showMissingStage ? (React.createElement(MissingStageWarning, null,
                React.createElement(AlertTriangle, { style: {
                        width: '13px',
                        height: '13px',
                        margin: '0.15em 0 -0.15em',
                    } }),
                ' ',
                lang.workflowStages.missingStageWarning)) : null),
            React.createElement(NodeIcons, null,
                showEditLinkIcon && (React.createElement(ExternalLink, { style: { cursor: 'pointer' }, onClick: () => c.redirect.redirect(`/settings/workflows/tasks/${updateType.updateTypeId}`) })),
                showDeleteIcon && (React.createElement(Trash2, { style: { color: THEME.COLOR_ACCENT, cursor: 'pointer' }, onClick: () => props.task && confirm(lang.workflows.sureYouWantToDeleteTask)
                        ? onDelete?.(props.task.id)
                        : null }))))),
        React.createElement("h3", null,
            updateType.procedureEnabled ? (React.createElement(Zap, { style: {
                    ...style,
                    ...(executedUpdate
                        ? {}
                        : {
                            color: THEME.COLOR_PRIMARY,
                        }),
                } })) : task?.pauseAtTiming?.details?.timespan[0] === 0 ? (React.createElement(Play, { style: style })) : updateType.pausing ? (React.createElement(Pause, { style: style })) : (React.createElement(Info, { style: style })),
            ' ',
            lang.updateTypes[updateType.updateTypeId] || updateType.label),
        taskStats && (React.createElement("p", { style: {
                marginTop: '-9px',
                fontWeight: 900,
            } },
            taskStats.currentTaskCases,
            ' ',
            React.createElement("span", { style: { opacity: 0.7 } }, lang.workflows.casesInTask),
            ' ',
            !!taskStats.currentTaskCases &&
                (redirecting ? (React.createElement(Loading, { style: {
                        width: '15px',
                        margin: '0px 1px -4px 1px',
                    } })) : (React.createElement(ExternalLink, { style: { cursor: 'pointer' }, onClick: () => {
                        goToCases();
                    } }))))),
        updateType.responsiblePermissionLevel &&
            !updateType.procedureEnabled &&
            task?.pauseAtTiming?.details?.timespan[0] !== 0 && (React.createElement("p", null,
            React.createElement(UserType, { role: updateType.responsiblePermissionLevel },
                lang.roles[updateType.responsiblePermissionLevel],
                ' '))),
        updateType.procedure && updateType.procedureEnabled && (React.createElement(Procedure, { procedure: updateType.procedure })),
        taskStats && (React.createElement("p", { style: { marginBottom: '0' } },
            React.createElement(CornerDownRight, { style: { color: THEME.SUCCESS, margin: '0.1em 0 -0.1em 0' } }),
            ' ',
            taskStats.totalCases === 0 || endedCasesQty === 0
                ? 0
                : ((endedCasesQty / taskStats.totalCases) * 100).toFixed(2),
            "% ",
            lang.workflows.endedCasesPercentage))));
};
export default UpdateType;
const UpdateTypeStyled = styled.div `
  text-align: left;
  user-select: none;

  ${(props) => (props.disabled ? 'opacity: 0.5;' : '')}

  & > h3 {
    font-size: 14px;
    margin-top: 0.5em;
  }
`;
const StageRow = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 1;
`;
const NodeIcons = styled.div `
  display: flex;
  align-items: center;
  gap: 5px;
`;
const WorkflowStageBadge = styled.span `
  display: inline-block;
  padding: 0 5px;
  border: 1px solid ${THEME.COLOR_ACCENT};
  border-radius: 3px;
  color: ${THEME.COLOR_ACCENT};
  font-size: 0.7em;
  font-weight: 600;
`;
const MissingStageWarning = styled.span `
  color: ${THEME.WARNING};
  font-size: 0.85em;
  font-weight: 600;
`;
//# sourceMappingURL=UpdateType.js.map